export default __webpack_public_path__ + "static/illustrationJourney-89dc89ded86ab069954493d4d074d8af.png";